// extracted by mini-css-extract-plugin
export default {"cover_letter":"CoverLetter_cover_letter__pdZcr","cl_textarea":"CoverLetter_cl_textarea__tRuFT","cl_text":"CoverLetter_cl_text__x8O5F"};